export default "__VITE_ASSET__d6e3b1f2__"